import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import BuyMerxToken from './BuyMerxToken';

import * as loadingActionTypes from '../../store/loading/loadingActionTypes';
import { buyTokenModalAction } from '../../store/token/tokenActions';
import MercurXModalLoadingOverlay from '../MercurXModalLoadingOverlay/MercurXModalLoadingOverlay';

function MercurXBuyTokenModal({ ...props }) {
  const { buyTokenModal, buyTokenModalRequest, isLoading } = props;
  const isBuyLoading = Boolean(isLoading?.[loadingActionTypes.BUY_MERXTOKEN_LOADING]);

  const handleClose = () => {
    if (isBuyLoading) {
      return;
    }
    buyTokenModalRequest(false);
  };

  return (
    <Modal
      show={buyTokenModal}
      onHide={handleClose}
      size="lg"
      centered
      scrollable
      backdrop={isBuyLoading ? 'static' : true}
      keyboard={!isBuyLoading}
      dialogClassName={`mercurx-buy-token-modal mercurx-modal-loading-shell${
        isBuyLoading ? ' mercurx-modal-loading-shell--loading mercurx-buy-token-modal--loading' : ''
      }`}
    >
      <Modal.Header
        closeButton={!isBuyLoading}
        className="border-bottom-0 mt-0 mb-0 p-2 bg-white"
      >
      </Modal.Header>
      <Modal.Body className="px-0 py-0">
        <BuyMerxToken />
      </Modal.Body>
      <MercurXModalLoadingOverlay
        show={isBuyLoading}
        variant="compact"
        eyebrow="Purchase In Progress"
        title="Waiting for wallet confirmation"
        description="Preparing and sending the token purchase. 
        Keep this window open while MetaMask confirms it."
        note="Modal is locked to avoid accidental close or double submit."
      />
    </Modal>
  );
}
const mapStateToProps = (state) => {
  return {
    buyTokenModal: state.tokenReducer.buyTokenModal,
    isLoading: state.loadingReducer.isLoading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    buyTokenModalRequest: (payload) => {
      dispatch(buyTokenModalAction(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MercurXBuyTokenModal);
